module.exports = __webpack_public_path__ + "static/about-us-03-8f1c19fa4d349ae49fa1de9bd0610fc1.png";